// Форма кода поверхности. Одна на всю систему.
//
// ⚠ Раньше эта форма была записана дважды — в генераторе тек
// (`scripts/new-surface.mjs`) и в реестре (`src/surfaces/registry.ts`), и
// равенство копий не держал ни один тест. Разойдутся — генератор начнёт делать
// теки, которые реестр отвергает, и поверхность не появится в системе молча
// (находка ревью таска 09).
//
// ⚠ Файл — обычный `.mjs`, а не `.ts`, намеренно: генератор запускается голым
// `node` (`npm run new-surface S-NN`), без сборки и без шага между командой и
// файлами на диске, поэтому ввезти `.ts` он не может. Типы лежат рядом в
// `code.d.mts` — тем же способом, каким типизирован сам генератор.
//
// ⚠ Флагов у выражения нет и быть не должно: `g` и `y` делают `RegExp`
// состоянием, и общий на всю систему `test` начал бы отвечать по-разному через
// раз, смотря кто звал его прошлым.

/** Код поверхности — ровно `S-` и две цифры (`docs/SCREEN-MAP.md`). */
export const SURFACE_CODE = /^S-\d{2}$/;
